import { render, staticRenderFns } from "./PessoasGeral.vue?vue&type=template&id=1ea42800&scoped=true&"
import script from "./PessoasGeral.vue?vue&type=script&lang=js&"
export * from "./PessoasGeral.vue?vue&type=script&lang=js&"
import style0 from "./PessoasGeral.vue?vue&type=style&index=0&id=1ea42800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea42800",
  null
  
)

export default component.exports